const PAGED_PREFIX = "paged";
const POSTS_PER_PAGE = 5;

module.exports = {
  PAGED_PREFIX,
  POSTS_PER_PAGE
};
